import {NxFormikNumberInput} from '@nextbank/ui-components';
import React from 'react';
import {DEFAULT_VALUE} from '../../../constants/static-field-values';
import {Field} from '../../../shared/model/field.model';
import {SetFieldValue} from '../../../shared/model/formik.model';
import {FieldDefaultCheckbox} from './FieldDefaultCheckbox';

interface Props {
  label: React.ReactNode;
  name: string;
  field: Field<unknown>;
  setFieldValue: SetFieldValue;
  max?: number;
  min?: number;
  step?: number;
  requiredButtonVisible?: boolean;
}

export const FieldDefaultNumberInput = (
  {label, name, field, setFieldValue, max, min, step, requiredButtonVisible}: Props
): React.ReactElement => (
  <FieldDefaultCheckbox name={name}
                        field={field}
                        setFieldValue={setFieldValue}
                        requiredButtonVisible={requiredButtonVisible}>
    <NxFormikNumberInput name={`${name}.${DEFAULT_VALUE}`} label={label} step={step} max={max} min={min} />
  </FieldDefaultCheckbox>
);

